module.exports = __webpack_public_path__ + "media/outside-2-270.ce04199c.mp4";